if (!customElements.get('product-modal')) {
	customElements.define('product-modal', class ProductModal extends ModalDialog {
		constructor() {
			super();

			this.closeEvent = new CustomEvent('product:modal-close');
			this.openEvent = new CustomEvent('product:modal-open');

			this._isZoomed = false;
			this._thumbsBuilt = false;
			this._initialized = false;
			this._activeIndex = 0;
			this._touchStartX = null;
		}

		hide() {
			super.hide();
			this._resetZoom();
			document.dispatchEvent(this.closeEvent);
		}

		show(opener) {
			this._init();
			super.show(opener);
			this.showActiveMedia(undefined, true);
			this._buildThumbnails();
			document.dispatchEvent(this.openEvent);
		}

		// Einmaliges Setup beim ersten Öffnen. Bewusst NICHT in
		// connectedCallback, um mit nichts zu kollidieren, was die
		// ModalDialog-Basisklasse dort selbst schon macht (das hat beim
		// ersten Versuch dazu geführt, dass sich das Modal gar nicht mehr
		// öffnen ließ).
		_init() {
			if (this._initialized) return;
			this._initialized = true;

			this.content = this.querySelector('.product-media-modal-content');
			this.thumbStrip = this.querySelector('.product-media-modal-thumbnails');
			this.prevBtn = this.querySelector('.product-media-modal-nav-prev');
			this.nextBtn = this.querySelector('.product-media-modal-nav-next');
			this.allItems = this.content
				? Array.prototype.slice.call(this.content.children).filter(function (el) {
						return el.hasAttribute('data-media-id') && el.getAttribute('data-media-id') !== 'metafield-video';
					})
				: [];
			this.items = this.allItems.slice();

			this._bindNav();
			this._bindZoom();
		}

		_refreshItems(activeMediaId, updateVariantSelection) {
			var gallery = this._getGallery();
			var hideVariants = gallery && gallery.getAttribute('hide-variants') === 'true';
			var activeId = activeMediaId ? activeMediaId.toString() : '';
			var activeItem = this.allItems.find(function (item) {
				return item.getAttribute('data-media-id') === activeId;
			});

			if (updateVariantSelection) {
				if (activeItem && activeItem.querySelector('.product-media-item-variant')) {
					this._selectedVariantMediaId = activeId;
				} else {
					var selectedVariantThumbnail = gallery && gallery.querySelector('.product-media-thumbnail-variant[data-media-id]');
					this._selectedVariantMediaId = selectedVariantThumbnail
						? selectedVariantThumbnail.getAttribute('data-media-id')
						: '';
				}
			}

			var selectedVariantId = this._selectedVariantMediaId || '';

			this.items = this.allItems.filter(function (item) {
				var isVariantImage = Boolean(item.querySelector('.product-media-item-variant'));
				return !hideVariants || !isVariantImage || item.getAttribute('data-media-id') === selectedVariantId;
			});

			var itemSignature = this.items.map(function (item) {
				return item.getAttribute('data-media-id');
			}).join('|');
			if (itemSignature !== this._itemSignature) {
				// Ein Variantenwechsel kann die erlaubten Modal-Medien ändern.
				// Deshalb wird die Thumbnail-Leiste für die aktuelle Auswahl neu aufgebaut.
				this._itemSignature = itemSignature;
				this._thumbsBuilt = false;
			}
		}

		// Hängt einen Handler an mehrere Event-Typen und stoppt jeweils die
		// Propagation. Der tatsächliche Übeltäter (jetzt aus der ModalDialog-
		// Quelle bekannt): weil unser Modal die Klasse "media-modal" trägt,
		// registriert die Basisklasse im Konstruktor einen "pointerup"-Listener
		// direkt auf <product-modal>, der bei JEDEM Maus-Klick im Modal schließt
		// – außer der Klick landet innerhalb von deferred-media/product-model
		// (Video/3D). Unsere Buttons/Thumbnails/Bilder sind davon nicht
		// ausgenommen, daher muss speziell "pointerup" hier abgefangen werden
		// (nicht nur click/mousedown/pointerdown).
		_interceptAndRun(element, handler) {
			['pointerdown', 'pointerup', 'mousedown', 'touchstart', 'click'].forEach(function (type) {
				element.addEventListener(
					type,
					function (event) {
						event.stopPropagation();
						if (type === 'click') handler(event);
					},
					{ passive: false }
				);
			});
		}

		showActiveMedia(mediaId, updateVariantSelection) {
			var id = mediaId || (this.openedBy && this.openedBy.getAttribute('data-media-id'));
			this._refreshItems(id, updateVariantSelection);
			if (!id || !this.items.length) return;

			this.allItems.forEach(function (element) {
				element.classList.remove('is-active');
			});

			var activeMedia = this.items.find(function (element) {
				return element.getAttribute('data-media-id') === id.toString();
			});
			if (!activeMedia) return;

			var activeMediaTemplate = activeMedia.querySelector('template');
			var activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
			activeMedia.classList.add('is-active');
			activeMedia.scrollIntoView();

			var container = this.querySelector('[role="document"]');
			if (container) {
				container.scrollLeft = ((activeMedia.offsetWidth || 0) - container.clientWidth) / 2;
			}

			if (
				activeMedia.nodeName == 'DEFERRED-MEDIA' &&
				activeMediaContent &&
				activeMediaContent.querySelector('.js-youtube')
			) {
				activeMedia.loadContent();
			}

			this._activeIndex = this.items.indexOf(activeMedia);
			this._resetZoom();
			this._syncThumbnails(id.toString());
		}

		/* ---------- Thumbnail-Leiste unten im Modal ---------- */

		_getGallery() {
			// Nutzt die bestehende Namenskonvention "ProductModal-{section.id}" /
			// "MediaGallery-{section.id}", um ohne zusätzliches Liquid-Setting
			// automatisch die passende Gallery zu diesem Modal zu finden.
			var galleryId = this.id.replace('ProductModal-', 'MediaGallery-');
			return document.getElementById(galleryId);
		}

		_buildThumbnails() {
			if (this._thumbsBuilt || !this.thumbStrip) return;

			var gallery = this._getGallery();
			if (!gallery) return;
			this.thumbStrip.replaceChildren();

			var self = this;
			var thumbnails = gallery.querySelectorAll('.product-media-thumbnail[data-media-id]');
			thumbnails.forEach(function (thumbnail) {
				var mediaId = thumbnail.getAttribute('data-media-id');

				// Nur ein Thumbnail bauen, wenn dieses Medium auch wirklich im
				// Modal vorhanden ist. Produktvideo und 3D-Renderings werden in
				// main-product.liquid absichtlich nicht ins Modal gerendert
				// (auf Wunsch entfernt) und stehen deshalb hier gar nicht in
				// this.items – ohne diesen Check gäbe es eine "toten" Thumbnail-
				// Button, der beim Klick nichts tut.
				var existsInModal = self.items.some(function (item) {
					return item.getAttribute('data-media-id') === mediaId;
				});
				if (!existsInModal) return;

				var sourceImg = thumbnail.querySelector('img');

				var button = document.createElement('button');
				button.type = 'button';
				button.className = 'product-media-modal-thumbnail';
				button.setAttribute('data-media-id', mediaId);
				button.setAttribute('role', 'tab');
				button.setAttribute('aria-label', (sourceImg && sourceImg.alt) || '');

				if (sourceImg) {
					var clone = sourceImg.cloneNode(true);
					clone.removeAttribute('sizes');
					clone.removeAttribute('srcset');
					clone.loading = 'lazy';
					button.appendChild(clone);
				}

				self._interceptAndRun(button, function () {
					self.showActiveMedia(mediaId);
				});
				self.thumbStrip.appendChild(button);
			});

			this._thumbsBuilt = true;
			this._syncThumbnails(this.openedBy && this.openedBy.getAttribute('data-media-id'));
		}

		_syncThumbnails(activeId) {
			if (!this.thumbStrip || !activeId) return;
			this.thumbStrip.querySelectorAll('.product-media-modal-thumbnail').forEach(function (button) {
				var isActive = button.getAttribute('data-media-id') === activeId.toString();
				button.classList.toggle('is-active', isActive);
				if (isActive) {
					button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
				}
			});
		}

		/* ---------- Links/Rechts-Navigation ---------- */

		_bindNav() {
			var self = this;
			if (this.prevBtn) {
				this._interceptAndRun(this.prevBtn, function () {
					self._step(-1);
				});
			}
			if (this.nextBtn) {
				this._interceptAndRun(this.nextBtn, function () {
					self._step(1);
				});
			}

			this.addEventListener('keydown', function (event) {
				if (event.key === 'ArrowLeft') self._step(-1);
				if (event.key === 'ArrowRight') self._step(1);
			});

			// Swipe nach links/rechts auf Touch-Geräten (nur wenn nicht gezoomt,
			// damit ein Swipe zum Schwenken im gezoomten Bild nicht versehentlich
			// das Bild wechselt).
			this.addEventListener(
				'touchstart',
				function (event) {
					if (self._isZoomed || !event.touches.length) return;
					self._touchStartX = event.touches[0].clientX;
				},
				{ passive: true }
			);

			this.addEventListener(
				'touchend',
				function (event) {
					if (self._touchStartX === null || self._isZoomed || !event.changedTouches.length) return;
					var deltaX = event.changedTouches[0].clientX - self._touchStartX;
					if (Math.abs(deltaX) > 40) self._step(deltaX < 0 ? 1 : -1);
					self._touchStartX = null;
				},
				{ passive: true }
			);
		}

		_step(direction) {
			if (!this.items.length) return;
			var nextIndex = (this._activeIndex + direction + this.items.length) % this.items.length;
			var nextId = this.items[nextIndex].getAttribute('data-media-id');
			this.showActiveMedia(nextId);
		}

		/* ---------- Zoom ---------- */

		_bindZoom() {
			if (!this.content) return;
			var self = this;

			['pointerdown', 'pointerup', 'mousedown', 'touchstart', 'click'].forEach(function (type) {
				self.content.addEventListener(
					type,
					function (event) {
						var zoomEl = event.target.closest('.pdp-modal-zoom');
						if (!zoomEl || !zoomEl.classList.contains('is-active')) return;
						event.stopPropagation();
						if (type === 'click') {
							self._toggleZoom(zoomEl, event.clientX, event.clientY);
						}
					},
					{ passive: false }
				);
			});

			this.content.addEventListener('mousemove', function (event) {
				if (!self._isZoomed) return;
				var zoomEl = self.querySelector('.pdp-modal-zoom.is-zoomed');
				if (zoomEl) self._panZoom(zoomEl, event.clientX, event.clientY);
			});

			this.content.addEventListener(
				'touchmove',
				function (event) {
					if (!self._isZoomed || !event.touches.length) return;
					var zoomEl = self.querySelector('.pdp-modal-zoom.is-zoomed');
					if (zoomEl) {
						// Verhindert, dass die Seite während des Schwenkens im
						// gezoomten Bild mitscrollt.
						event.preventDefault();
						self._panZoom(zoomEl, event.touches[0].clientX, event.touches[0].clientY);
					}
				},
				{ passive: false }
			);
		}

		_toggleZoom(zoomEl, clientX, clientY) {
			if (zoomEl.classList.contains('is-zoomed')) {
				this._resetZoom();
				return;
			}

			var img = zoomEl.querySelector('img');
			var zoomSrc = zoomEl.dataset.zoomSrc;
			if (img && zoomSrc && img.src !== zoomSrc) {
				img.dataset.originalSrc = img.currentSrc || img.src;
				img.src = zoomSrc;
				img.removeAttribute('srcset');
			}

			zoomEl.classList.add('is-zoomed');
			this._isZoomed = true;
			this._panZoom(zoomEl, clientX, clientY);
		}

		_panZoom(zoomEl, clientX, clientY) {
			var img = zoomEl.querySelector('img');
			if (!img) return;
			var rect = zoomEl.getBoundingClientRect();
			var x = ((clientX - rect.left) / rect.width) * 100;
			var y = ((clientY - rect.top) / rect.height) * 100;
			img.style.transformOrigin = Math.min(Math.max(x, 0), 100) + '% ' + Math.min(Math.max(y, 0), 100) + '%';
		}

		_resetZoom() {
			var zoomEl = this.querySelector('.pdp-modal-zoom.is-zoomed');
			if (zoomEl) {
				zoomEl.classList.remove('is-zoomed');
				var img = zoomEl.querySelector('img');
				if (img) {
					if (img.dataset.originalSrc) {
						img.src = img.dataset.originalSrc;
						delete img.dataset.originalSrc;
					}
					img.style.transformOrigin = '';
				}
			}
			this._isZoomed = false;
		}
	});
}
